module.exports = __webpack_public_path__ + "img/cherry_blossom.e443aed8.jpg";